const mutations = {
	['UPDATE_APP_INFO'] (state, appInfo) {
		state.themeColor = appInfo.themeColor;
		state.virtualCurrencyUnit = appInfo.virtualCurrencyUnit;
		state.appname = appInfo.appname;
	},

	['UPDATE_APP_BASE_INFO'] (state, payload) {
		state.appid = payload.appid;
		state.redirectURL = payload.redirectURL;
	},
};

export default mutations;